import React, { useState, useEffect } from 'react';
import './MeteoWidget.css';

function MeteoWidget({ zone, onChangeZone }) {
  const [meteo, setMeteo] = useState(null);
  const [loading, setLoading] = useState(false);
  const [expanded, setExpanded] = useState(true);

  useEffect(() => {
    loadMeteo();
  }, [zone]);

  const loadMeteo = async () => {
    setLoading(true);
    // Données fallback temporaires (en attendant l'API)
    setTimeout(() => {
      setMeteo({
  zone: zone,
  situation_generale: "Anticyclone des Açores stable sur l'Atlantique. Temps calme prévu.",
  previsions_jour: "Vent de Nord-Est force 2 à 3. Mer belle. Visibilité excellente.",
  previsions_nuit: "Vent faible variable. Mer calme. Visibilité bonne.",
  pression: 1015,
  tendance_barometre: "stable",
  bms: [],
  updated_at: new Date()
});
      setLoading(false);
    }, 500);
  };

  const zones = [
    { value: 'manche', label: 'Manche' },
    { value: 'atlantique', label: 'Atlantique' },
    { value: 'mediterranee', label: 'Méditerranée' }
  ];

  return (
    <div className="meteo-widget">
      <div className="meteo-header" onClick={() => setExpanded(!expanded)}>
        <h2>🌊 Météo Marine - {zones.find(z => z.value === zone)?.label}</h2>
        <div className="meteo-controls">
          <select 
            value={zone} 
            onChange={(e) => {
              e.stopPropagation();
              onChangeZone(e.target.value);
            }}
            className="zone-selector"
          >
            {zones.map(z => (
              <option key={z.value} value={z.value}>{z.label}</option>
            ))}
          </select>
          <button className="toggle-btn">
            {expanded ? '▼' : '▶'}
          </button>
        </div>
      </div>

      {expanded && (
        <div className="meteo-content">
          {loading ? (
            <div className="loading">Chargement météo marine...</div>
          ) : (
            <>
              {meteo?.bms && meteo.bms.length > 0 && (
                <div className="bms-alert">
                  <strong>⚠️ BULLETINS MÉTÉO SPÉCIAUX</strong>
                  <ul>
                    {meteo.bms.map((bms, idx) => (
                      <li key={idx}>{bms}</li>
                    ))}
                  </ul>
                </div>
              )}

              <div className="meteo-section">
                <h3>📰 Situation générale</h3>
                <p>{meteo?.situation_generale}</p>
              </div>

              <div className="meteo-section">
                <h3>🌅 Prévisions du jour</h3>
                <p>{meteo?.previsions_jour}</p>
              </div>

              <div className="meteo-section">
                <h3>🌙 Prévisions de la nuit</h3>
                <p>{meteo?.previsions_nuit}</p>
              </div>
              <div className="meteo-section">
  <h3>🌡️ Pression atmosphérique</h3>
  <p>
    <strong>{meteo?.pression} hPa</strong>
    {meteo?.tendance_barometre && (
      <span style={{ marginLeft: '10px' }}>
        {meteo.tendance_barometre === 'hausse' && '📈 En hausse'}
        {meteo.tendance_barometre === 'baisse' && '📉 En baisse'}
        {meteo.tendance_barometre === 'stable' && '➡️ Stable'}
      </span>
    )}
  </p>
</div>

              <div className="meteo-footer">
                <small>
                  Dernière mise à jour : {new Date(meteo?.updated_at).toLocaleString()}
                </small>
                <button onClick={loadMeteo} className="refresh-btn">
                  🔄 Actualiser
                </button>
              </div>
            </>
          )}
        </div>
      )}
    </div>
  );
}

export default MeteoWidget;